import Vue from 'vue';
import Child from './Child';
import HeaderBar from './HeaderBar';

// Components that are registered globaly.
[
    Child,
    HeaderBar,
].forEach((Component) => {
    Vue.component(Component.name, Component);
});